import React from "react";
import { Input } from "../../../../controls";
import { DiscountAdjustment } from "../../../../hooks/Method";

const InputReturnQty = ({
  setSellItems,
  sellItems,
  setValues,
  handleInpChg,
  item,
}) => {
  const calcReturnAmt = (item, returnQty) => {
    const originalAmt = item.qty * item.price;
    const returnAmt = returnQty * item.price;
    const { discountOnReturn, refundAmt } = DiscountAdjustment(
      originalAmt,
      item.disAmt,
      returnAmt
    );
    // Update State
    setSellItems([
      ...sellItems.map((j) =>
        j.id === item.id
          ? { ...j, discAdj: discountOnReturn, returnAmt: refundAmt }
          : j
      ),
    ]);
    setValues((j) => ({
      ...j,
      returnItems: j.returnItems.map((k) =>
        k.id === item.id
          ? { ...k, discAdj: discountOnReturn, returnAmt: refundAmt }
          : k
      ),
    }));
  };

  return (
    <div className="flex flex-col gap-1">
      <Input
        placeholder="Return Quantity"
        name="returnQty"
        type="number"
        size="small"
        variant="outlined"
        value={item.returnQty}
        onFocus={(e) => e.target.select()}
        onBlur={(e) => calcReturnAmt(item, parseFloat(e.target.value || 0))}
        onChange={(e) => {
          const inputValue = parseFloat(e.target.value) || 0;
          const currentLength = e.target.value.length;
          const prevLength = item.returnQty.toString().length;

          const isValidInput =
            item.qty >= inputValue || prevLength > currentLength;

          if (isValidInput) {
            handleInpChg({
              id: item.id,
              name: "returnQty",
              value: e.target.value,
            });
          }
        }}
        sx={{
          "& .MuiInputBase-root": {
            padding: "0px 0px",
            maxWidth: "150px",
          },
          "& .MuiInputBase-input": {
            padding: "4px 10px",
            fontSize: "14px",
          },
        }}
      />
      <span className="text-[12px] font-medium pl-1 uppercase">
        Purchase Qty: {item.qty}
      </span>
    </div>
  );
};

export default InputReturnQty;
